export const TableActionTypes = {
  setPaginationOptions: 'TABLE_SET_PAGINATION_OPTIONS',
  clearPaginationOptions: 'TABLE_CLEAR_PAGINATION_OPTIONS',
  setPaginationSearch: 'TABLE_SET_PAGINATION_SEARCH',
  setPaginationAction: 'TABLE_SET_PAGINATION_ACTION',
  setPaginationSearchSpinner: 'TABLE_SET_SEARCH_SPINNER',
};
